// Fill presets for the Color section: gradient recipes (FillValue shape,
// resolved by posterTools resolveFill) and the bundled seamless texture
// manifest (app/public/textures/*.png — same-origin so exports never taint).
//
// Texture PORTABILITY LAW: the JSON's data.textFill stores the texture *id*,
// never a URL. URLs are deployment-specific (this dev box serves under
// /pse/); the engine re-resolves id → textureUrl(id) at load time, so a
// design saved here renders in any deployment of the app.

export const GRADIENT_PRESETS = [
  { id: 'sunset', label: 'Sunset', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#f97316' }, { offset: 1, color: '#ec4899' }], angle: 90 } },
  { id: 'ocean', label: 'Ocean', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#06b6d4' }, { offset: 1, color: '#3b82f6' }], angle: 90 } },
  { id: 'forest', label: 'Forest', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#84cc16' }, { offset: 1, color: '#166534' }], angle: 90 } },
  { id: 'cherry', label: 'Cherry', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#f472b6' }, { offset: 1, color: '#be123c' }], angle: 90 } },
  {
    id: 'rainbow', label: 'Rainbow',
    fill: {
      type: 'linear-gradient', angle: 0,
      stops: [
        { offset: 0, color: '#ef4444' }, { offset: 0.2, color: '#f59e0b' },
        { offset: 0.4, color: '#eab308' }, { offset: 0.6, color: '#22c55e' },
        { offset: 0.8, color: '#3b82f6' }, { offset: 1, color: '#8b5cf6' },
      ],
    },
  },
  { id: 'gold', label: 'Gold', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#fde68a' }, { offset: 0.5, color: '#d97706' }, { offset: 1, color: '#fde68a' }], angle: 60 } },
  { id: 'berry', label: 'Berry', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#a855f7' }, { offset: 1, color: '#6366f1' }], angle: 135 } },
  { id: 'sky', label: 'Sky', fill: { type: 'linear-gradient', stops: [{ offset: 0, color: '#e0f2fe' }, { offset: 1, color: '#38bdf8' }], angle: 90 } },
];

import manifest from './textureManifest.json';

/** The full bundled library — generated manifest (id/label/category/file/
 * tile/featured). ids are the persistence contract (data.textFill stores
 * them); files/labels/categories may evolve, ids must not. */
export const TEXTURES = manifest.textures;
export const TEXTURE_CATEGORIES = manifest.categories;

/** Sidebar shows only the featured handful; the full library lives in the
 * Texture Explorer modal. */
export const TEXTURES_FEATURED = manifest.textures.filter((t) => t.featured);

const BY_ID = new Map(manifest.textures.map((t) => [t.id, t]));

export function textureById(id) {
  return BY_ID.get(id) ?? null;
}

/** Deployment-relative URL for a bundled texture id. Unknown ids fall back
 * to the legacy {id}.png convention so old saved recipes keep resolving. */
export function textureUrl(id) {
  const entry = BY_ID.get(id);
  return `${import.meta.env.BASE_URL}textures/${entry ? entry.file : `${id}.png`}`;
}
